// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__ovqFe","title":"Header_title__PLEpo","subText":"Header_subText__6LSVv","button":"Header_button__ZHO8V","wrapperTooltip":"Header_wrapperTooltip__suxbC"};